import { TooltipComponent } from "../TooltipComponent/TooltipComponent";
import { _ } from "i18n";
import clsx from "clsx";
import { DataSourceOption } from "./types";

interface DataSourceSelectorProps {
	options: DataSourceOption[],
	selected: string | null,
	onChange: (scope: string) => void;
}

export function DataSourceSelector({ options, selected, onChange }: DataSourceSelectorProps) {
	if (options.length < 2 || selected === "team_groups") {
		return null;
	}

	return (
		<div className="gender-selection">
			<div className="gender-options" role="radiogroup">
				{options.map((o: DataSourceOption) => {
					if (o.key === "team_groups") {
						return null;
					}

					if (o.isSelectable) {
						return (
							<label
								key={o.key}
								className={clsx("gender-options__item", { "is-selected": o.key === selected })}
							>
								<input
									checked={o.key === selected}
									type="radio"
									name="elite-discover-dummy"
									value={o.key}
									className="gender-options__input"
									onChange={(e) => onChange(e.target.value as string)}
								/>
								<span className="gender-options__text">{o.label}</span>
							</label>
						);
					}

					return (
						<TooltipComponent
							key={o.key}
							title={_("tooltip.comingsoon")}
							variant="dark"
							delay={500}
							size="large"
						>
							<label className="gender-options__item">
								<input
									type="radio"
									name="elite-discover-dummy"
									value={o.key}
									disabled
									className="gender-options__input"
									tabIndex={-1}
								/>
								<span className="gender-options__text">{o.label}</span>
							</label>
						</TooltipComponent>
					);
				})}
			</div>
		</div>
	);
}
